/* Mood & Life · formularios (contacto, hoteles, hostelería, supermercado y newsletter). Sin cambiar a dónde se envían:
   - mensajes de validación en español y "marca al menos una opción" en los grupos [data-min1];
   - tras el envío (Shopify vuelve con ?contact_posted=true#id-del-formulario o ?customer_posted=true), el aviso de "recibido" sale
     SOLO en el formulario enviado, con foco; los errores de Shopify (role=alert) reciben el foco;
   - copia de la solicitud a la hoja (webhook de Zapier, ajuste del tema "URL del webhook de solicitudes"), solo en los formularios
     de contacto, como text/plain (sin preflight) y con keepalive, y SOLO tras la vuelta de Shopify con contact_posted=true.
   - teléfono, campo trampa y tiempo mínimo: assets/ml-telefono.js (se carga antes). */
(function () {
  var MSG = { vacio: 'Rellena este campo.', email: 'Escribe un email válido, por ejemplo nombre@dominio.com.', chk: 'Marca la casilla para continuar.', min1: 'Marca al menos una opción.', num: 'Escribe un número válido.', sel: 'Elige una opción.' };
  function mensaje(c) {
    var v = c.validity; if (v.valid) return '';
    if (c.type === 'checkbox') return MSG.chk;
    if (c.tagName === 'SELECT') return MSG.sel;
    if (v.typeMismatch && c.type === 'email') return MSG.email;
    if (v.badInput || v.rangeUnderflow || v.rangeOverflow || v.stepMismatch) return MSG.num;
    return MSG.vacio;
  }
  var forms = [].slice.call(document.querySelectorAll('form.f'));
  forms.forEach(function (f) {
    f.querySelectorAll('input,select,textarea').forEach(function (c) {
      if (c.closest('fieldset[data-min1]')) return;   // los grupos "al menos una" llevan su propia comprobación
      c.addEventListener('invalid', function () { c.setCustomValidity(''); if (!c.validity.valid) c.setCustomValidity(mensaje(c)); });
      c.addEventListener('input', function () { c.setCustomValidity(''); });
      c.addEventListener('change', function () { c.setCustomValidity(''); });
    });
    f.querySelectorAll('fieldset[data-min1]').forEach(function (fs) {
      var cs = [].slice.call(fs.querySelectorAll('input[type=checkbox]'));
      function revisa() { var alguno = cs.some(function (x) { return x.checked; }); cs[0].setCustomValidity(alguno ? '' : MSG.min1); }
      cs.forEach(function (x) { x.addEventListener('change', revisa); }); revisa();
    });
  });
  // copia a la hoja (solo formularios de contacto). Desde el 15 oct ya NO sale al enviar: al enviar se guardan los campos en
  // sessionStorage y el POST al webhook sale solo cuando Shopify vuelve con contact_posted=true (es decir, cuando ya lo ha aceptado,
  // captcha incluido). Después se borra lo guardado. Con la vista previa, ml-vista-previa recarga con ?view=: lo guardado sigue ahí.
  var url = window.mlWebhook || '', KW = 'ml-webhook-pendiente';
  forms.forEach(function (f) {
    if (!f.querySelector('input[name="form_type"][value="contact"]')) return;
    f.addEventListener('submit', function (ev) {
      if (ev.defaultPrevented || !url || !f.checkValidity()) return;
      try {
        var d = {}; new FormData(f).forEach(function (v, k) { var m = k.match(/^contact\[(.+)\]$/); if (m) d[m[1]] = v; });
        d.pagina = location.href.split('#')[0].replace(/[?&](view|preview_theme_id)=[^&]*/g, ''); d.fecha = new Date().toISOString(); d.idioma = document.documentElement.lang || 'es';
        sessionStorage.setItem(KW, JSON.stringify({ t: Date.now(), form: f.id, datos: d }));
      } catch (e) {}
    });
  });
  (function () {
    if (!/contact_posted=true/.test(location.search)) return;
    var g; try { g = JSON.parse(sessionStorage.getItem(KW) || 'null'); sessionStorage.removeItem(KW); } catch (e) { return; }
    if (!g || !g.datos || !url || Date.now() - g.t > 3600000) return;     // nada pendiente, o de hace más de una hora
    try { fetch(url, { method: 'POST', keepalive: true, mode: 'no-cors', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: JSON.stringify(g.datos) }).catch(function () {}); } catch (e) {}
  })();
  // aviso de enviado, solo en el formulario enviado
  var q = location.search, h = location.hash.slice(1);
  if (/contact_posted=true/.test(q)) {
    forms.forEach(function (f) {
      var hecho = f.querySelector('.hecho'); if (!hecho) return;
      if (h && f.id !== h) { hecho.remove(); return; }
      var ok = f.parentElement.querySelector('.ok'), sel = f.querySelector('[data-ok-por-valor]');
      [].slice.call(f.children).forEach(function (n) { if (n !== hecho && n.tagName !== 'INPUT') n.hidden = true; });
      hecho.tabIndex = -1; hecho.classList.add('hecho-grande'); setTimeout(function () { hecho.focus(); hecho.scrollIntoView({ block: 'center' }); }, 60);
    });
  }
  if (/customer_posted=true/.test(q)) {
    var fn = document.querySelector('form.f.linea'); var hn = fn && fn.querySelector('.hecho');
    if (hn) { [].slice.call(fn.children).forEach(function (n) { if (n !== hn && n.tagName !== 'INPUT') n.hidden = true; }); hn.tabIndex = -1; hn.classList.add('hecho-grande'); setTimeout(function () { hn.focus(); hn.scrollIntoView({ block: 'center' }); }, 60); }
  }
  var err = document.querySelector('form.f .err[role=alert]');
  if (err) { err.tabIndex = -1; setTimeout(function () { err.focus(); err.scrollIntoView({ block: 'center' }); }, 60); }
})();
